import { APICore } from "helpers/api/apiCore";
import config from "config";

const api = new APICore();

function createProgrammesDumpReportApi(params: any) {
  let apiData: any = {
    programExternalId: params.programExternalId,
    saveReport: params.saveReport
  };

  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/programmes-dump-report`;

  return api.create(`${backendApiUrl}`, apiData);
}

export { createProgrammesDumpReportApi };